import React, { useState, useEffect } from 'react'
import { HiOutlineArrowSmRight } from "react-icons/hi";
import ContactModal from "../../modal/ContactModal";

const rainbowLogo = process.env.PUBLIC_URL + '/images/logo.png';

export default function Desktop() {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <header className='fixed top-0 left-0 right-0 z-[100] flex justify-center px-[12px] sm:px-[20px] lg:px-[32px] pt-[10px] sm:pt-[16px] pointer-events-none transition-all duration-300'>
                <div 
                    className={`pointer-events-auto flex justify-between items-center w-full max-w-[1440px] py-[10px] sm:py-[12px] xl:py-[16px] px-[16px] sm:px-[28px] xl:px-[42px] relative z-[100] rounded-full transition-all duration-300 ${
                        isScrolled 
                            ? 'bg-white/95 backdrop-blur-md shadow-[0_12px_40px_rgba(0,0,0,0.18)] border border-gray-100/90 py-[8px] sm:py-[10px]' 
                            : 'bg-white/85 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.22)] border border-white/40'
                    }`}
                >
                    <a title='Rainbow Trucks' href='/' className='relative flex items-center group transition-transform duration-200 hover:scale-[1.02] shrink-0'>
                        <img src={rainbowLogo} alt='rainbow trucks' loading='lazy' className='relative w-[130px] sm:w-[160px] lg:w-[185px] xl:w-[205px] h-auto object-contain' />
                    </a>

                    <nav className='hidden lg:flex items-center gap-4 xl:gap-8 text-[13px] xl:text-[14px] font-semibold text-[#181F38] absolute left-1/2 -translate-x-1/2'>
                        <a href='/#about' className='hover:text-[#73C8BD] transition-colors whitespace-nowrap'>About Us</a>
                        <a href='/products' className='hover:text-[#73C8BD] transition-colors whitespace-nowrap'>Our Products</a>
                        <a href='/#franchise-options' className='hover:text-[#73C8BD] transition-colors whitespace-nowrap'>Franchise</a>
                        {localStorage.getItem('isLoggedIn') === 'true' ? (
                            <>
                                <a href='/orders' className='hover:text-[#73C8BD] transition-colors whitespace-nowrap'>Order History</a>
                                <a href='/' onClick={(e) => { localStorage.removeItem('isLoggedIn'); localStorage.removeItem('userEmail'); }} className='hover:text-[#73C8BD] transition-colors whitespace-nowrap'>Logout</a>
                            </>
                        ) : (
                            <a href='/login' className='hover:text-[#73C8BD] transition-colors whitespace-nowrap'>Login</a>
                        )}
                    </nav>

                    <button 
                        type='button'
                        onClick={() => setIsContactModalOpen(true)}
                        className='group bg-[#73C8BD] hover:bg-[#5ebcae] active:scale-95 px-[16px] sm:px-[22px] xl:px-[26px] h-[38px] sm:h-[44px] xl:h-[48px] flex justify-center items-center gap-[6px] sm:gap-[10px] cursor-pointer rounded-full text-[#FFF] font-semibold text-[13px] sm:text-[14px] xl:text-[15px] shadow-[0_4px_14px_rgba(115,200,189,0.45)] hover:shadow-[0_6px_20px_rgba(115,200,189,0.65)] transition-all duration-300 shrink-0'
                    >
                        <span>Contact Us</span>
                        <HiOutlineArrowSmRight className='text-[16px] sm:text-[18px] xl:text-[20px] transition-transform duration-200 group-hover:translate-x-1' />
                    </button>
                </div>
            </header>

            <ContactModal 
                isOpen={isContactModalOpen} 
                onClose={() => setIsContactModalOpen(false)} 
            />
        </>
    )
}
